export default "__VITE_ASSET__DcyXNYLN__"